import { Injectable } from '@angular/core';
import { ProductEndpoint } from './product-endpoint.service';
import { Product } from 'src/app/models/product';
import { Observable } from 'rxjs';

@Injectable({
    providedIn: 'root'
})
export class ProductService {

    constructor(
        private productEndpoint: ProductEndpoint
    ) {

    }

    getProducts(tenantId: string): Observable<Product[]> {
        return this.productEndpoint.getProducts(tenantId);
    }

}
